var map = {
	"./app-store.svg": "db07",
	"./arrow-left.svg": "c633",
	"./arrow-right.svg": "2a29",
	"./card-basic.svg": "9626",
	"./card-bg-bvic.svg": "9ab3",
	"./card-bg-tvic.svg": "fe58",
	"./card-bg-vic-black.svg": "590f",
	"./card-bg-vic-gold.svg": "88fd",
	"./card-bg-vic.svg": "4c4e",
	"./card-bg.svg": "aec9",
	"./card-black.svg": "b685",
	"./card-gold.svg": "0fb2",
	"./card-logo.svg": "1b7d",
	"./cross.svg": "2872",
	"./diamond.svg": "5ef0",
	"./gift.svg": "3030",
	"./icon-card-sm.svg": "04c2",
	"./language.svg": "8767",
	"./logo-bvic.svg": "a140",
	"./logo-tvic.svg": "c97e",
	"./logo-vic.svg": "aea2",
	"./logo.svg": "d191",
	"./menu.svg": "b778",
	"./play-store.svg": "9eb6",
	"./star.svg": "8599",
	"./token.svg": "b20e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad74";